import styled from '@emotion/styled';

export const DetailOuterWrap = styled.div`
  margin: 0 auto;
  max-width: 1380px;
  padding: 8px 16px;
  @media (min-width: 768px) {
    padding: 24px;
  }
  @media (min-width: 1024px) {
    padding: 32px 40px;
  }
  @media (min-width: 1260px) {
    margin: 50px auto 0;
    padding: 0px 40px;
  }
`;

export const DetailWrap = styled.div`
  align-items: center;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  svg {
    max-width: 20px;
  }
  @media (min-width: 768px) {
    padding: 0px;
    display: flex;
  }
  @media (min-width: 1023px) {
    display: none;
  }
`;

export const Wrapper = styled.div`
  @media (min-width: 1024px) {
    margin: 0 auto;
    width: 100%;
  }
`;

export const OuterWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  width: 100%;
  flex-direction: column;
  @media (min-width: 1024px) {
    margin-top: 16px;
    flex-direction: row;
  }
`;

export const InnerWrapper = styled.div`
  width: 100%;
`;

export const TitleNumberWrap = styled.div`
  @media (min-width: 768px) {
    align-items: center;
    display: flex;
  }
`;

export const TitleNumber = styled.div`
  color: #444340;
  font-weight: bold;
  margin-right: 20px;
  @media (min-width: 768px) {
    padding-left: 8px;
  }
  @media (min-width: 1024px) {
    font-weight: normal;
  }
`;

export const DownloadStyles = styled.div`
  @media (min-width: 768px) {
    padding-left: 60px;
  }
`;

export const OrderedStyles = styled.div`
  @media (min-width: 768px) {
    padding-left: 30px;
  }
`;

export const BackStyles = styled.a`
  background-color: #fff;
  border: none;
  cursor: pointer;
  padding: 0;
  :hover {
    background-color: #fff;
  }
`;

export const InnerDetail = styled.div`
  align-items: center;
  color: #444340;
  display: flex;
  justify-content: space-between;
  @media (max-width: 767px) {
    .iconButtonStyles {
      max-width: 32px;
    }
  }
`;

export const DetailWrapDesktop = styled.div`
  border-bottom: 1px solid #e5e5ea;
  border-top: 1px solid #e5e5ea;
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  justify-content: space-between;
  padding: 8px 0px 8px 0px;
  position: relative;
  width: auto;
  button {
    margin-right: 8px;
    svg {
      max-width: 20px;
      width: 100%;
      height: auto;
    }
  }
  @media (max-width: 520px) {
    button {
      margin-right: 8px;
      svg {
        display: none;
      }
    }
  }
  @media (max-width: 1023px) {
    margin-bottom: 16px;
    button {
      font-size: 11px;
      margin-right: 16px;
      white-space: nowrap;
      width: auto;
    }
  }
  @media (min-width: 1024px) {
    border-radius: 5px;
    border: 1px solid #e5e5ea;
    height: 72px;
    padding: 8px 14px 8px 32px;
    button {
      height: 40px;
    }
  }
  @media (min-width: 1260px) {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const OrderDetailsButton = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  svg {
    margin-left: 6px;
    margin-top: 1px;
  }
  @media (min-width: 1024px) {
    background: #ffffff;
    border-radius: 5px;
    border: 1px solid #e5e5ea;
    height: 40px;
    padding: 0 24px;
    svg {
      max-width: 6px;
    }
    :hover {
      border-color: #333;
    }
  }
`;

export const SearchesHeader = styled.div`
  @media (max-width: 1022px) {
    display: none;
  }
  align-items: center;
  display: flex;
  font-weight: bold;
  margin: 40px 0 0 40px;
  padding-top: 24px;
  @media (min-width: 1630px) {
    margin-top: 16px;
  }
`;

export const GroupedBy = styled.div`
  align-items: center;
  background-color: #fcf3e8;
  border-radius: 1px;
  cursor: pointer;
  display: flex;
  margin-left: 16px;
  padding: 8px 10px;
  :hover {
    background-color: #fadeae;
  }
`;

export const OuterCard = styled.div`
  border-radius: 5px;
  border: 1.5px solid #eae8e5;
  margin: 8px 0px;
  padding: 16px;
  @media (min-width: 1024px) {
    margin: 0 auto 16px;
    padding: 40px 16px;
    width: 100%;
    span {
      background-color: #444340;
      color: #fff;
    }
    p {
      font-weight: 600;
    }
  }
`;

export const ClosedCard = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  position: relative;
  @media (min-width: 1023px) {
    display: block;
  }
`;

export const PropertyInfo = styled.div`
  align-items: center;
  justify-content: space-between;
  display: flex;
  @media (min-width: 1023px) {
    padding-left: 16px;
    .card-header {
      font-size: 20px;
      text-transform: uppercase;
      font-weight: 700;
    }
  }
`;

export const DetailSectionDesktop = styled.div`
  display: none;
  @media (min-width: 1024px) {
    align-items: center;
    color: #93918f;
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
    margin-top: 8px;
    padding-left: 16px;
  }
`;

export const NumberStyles = styled.span`
  align-items: center;
  border: 1px solid #444340;
  display: flex;
  height: 24px;
  justify-content: center;
  margin-right: 16px;
  width: 24px;
`;

export const ArrowStyles = styled.div`
  position: absolute;
  right: 40px;
  top: 8px;
  @media (min-width: 1023px) {
    display: none;
  }
`;

export const ExpandSection = styled.div`
  padding: 16px 16px 16px 0;
  @media (min-width: 1023px) {
    display: none;
  }
`;

export const ClosedSearches = styled.div`
  @media (max-width: 1023px) {
    display: none;
  }
  align-items: center;
  border-top: 1px solid #ccc9c6;
  display: flex;
  flex-wrap: wrap;
  padding-top: 16px;
`;

export const DetailSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media (min-width: 1024px) {
    padding-bottom: 16px;
  }
`;

export const Details = styled.div`
  /* border-right: 1px solid #93918f; */
  /* width: 15%; */
  /* padding-left: 8px; */
  padding-right: 16px;
  /* margin-bottom: 8px; */
  :last-of-type {
    border-right: none;
  }
  @media (min-width: 1024px) {
    border-right: none;
    display: flex;
    /* font-size: 14px; */
    /* padding-right: 0px; */
  }
`;

export const DetailTitle = styled.div`
  color: #93918f;
  font-size: 10px;
  @media (min-width: 1024px) {
    color: #93918f;
    font-size: 12px;
    padding-right: 8px;
  }
`;

export const SearchCardStyles = styled.div`
  background-color: #fff;
  border: 1px solid #93918f;
  margin-top: 8px;
  padding: 12px;
  @media (min-width: 767px) {
    display: none;
  }
`;

export const SearchCardInBetween = styled.div`
  @media (min-width: 1023px) {
    display: none;
  }
`;

export const SearchCardDesktop = styled.div`
  @media (max-width: 1023px) {
    display: none;
  }
  @media (min-width: 1024px) {
    display: block;
    margin: 16px 0px 0px;
    width: 100%;
  }
`;

export const SearchDetailTitle = styled.div`
  color: #ccc9c6;
  font-size: 9px;
  text-transform: uppercase;
`;

export const SearchHeaders = styled.div`
  border-bottom: 1px solid #eae8e5;
  color: #93918f;
  display: grid;
  font-size: 11px;
  grid-column-gap: 1%;
  grid-template-columns: 34% 19% 27% 13% 5%;
  margin-top: 16px;
  padding: 16px;
  text-transform: uppercase;
  width: 100%;
  @media (min-width: 1024px) {
    font-size: 14px;
    position:relative;
  }
`;

export const SearchInfo = styled.div<{
  cursor?: string;
}>`
  align-items: center;
  border-bottom: 1px solid #eae8e5;
  display: grid;
  font-size: 14px;
  grid-column-gap: 1%;
  grid-template-columns: 34% 19% 27% 13% 5%;
  padding: 16px;
  width: 100%;
  cursor: ${props => (props.cursor)};
  :last-of-type {
    border-bottom: none;
    padding-bottom: 0;
  }
  @media (min-width: 1024px) {
    font-size: 14px;
    padding-left:24px;
  }
`;
export const DropdownStyles = styled.div`
  padding: 25px 40px;
  display: flex;
  button{
   margin-right:8px;
  }
`;
export const DropdownOuter = styled.div<{
  height?: string;
}>`
  background: #f7f7f9;
  transition: all .2s ease;
  height: ${props => (props.height)};
`;
export const SidebarSummaryStyles = styled.div`
  position: absolute;
  width: 100%;
  font-weight: 300;
`;

export const SummaryHeader = styled.div`
  background-color: #f5f5f5;
  padding: 30px 20px 30px 56px;
`;

export const OrderInfo = styled.div`
  color: #33322f;
  font-weight: bold;
  font-size: 18px;
  text-transform: uppercase;
`;

export const TitleStyles = styled.div`
  color: #93918f;
  font-size: 12px;
  width: 30%;
  text-transform: uppercase;
`;

export const OuterWrap = styled.div`
  padding: 30px 20px 30px 56px;
`;

export const GreyBackground = styled.div`
  background-color: #f5f5f5;
  padding: 10px;
  width: 384px;
  margin-top: 4px;
`;

export const TabStyles = styled.div<{
  color?: string;
  backgroundColor?: boolean;
  border?: boolean;
}>`
  align-items: center;
  background-color: ${props => (props.backgroundColor ? '#fff' : '#EAE8E5')};
  border: ${props => (props.border ? '1px solid #FFDBC7' : 'none')};
  color: #33322f;
  cursor: pointer;
  display: flex;
  font-weight: 500;
  height: 40px;
  justify-content: center;
  margin-top: 16px;
  width: 128px;
  :hover {
    /* color: ${props => (props.color ? '#BCC2C7' : '#33322F')}; */
    color: ${props => props.color};
  }
`;
